module.exports = __webpack_public_path__ + "res/img/icon-total.fb297922.png";